const commonAndMisc = {
  errorMessage404: "Oeps! De pagina die u zoekt bestaat niet", // translated
  backToHome: "Terug naar huis", // translated
  information: "Informatie", // translated
  additionalInformation: "Extra informatie", // translated
  destinationPlaceholder: "Waar ga je heen", // translated
  aboutUs: "Over ons", // translated
  pleaseWait: "Even geduld aub...", // translated
  featuredHotels: "Aanbevolen hotels", // translated
  topPackages: "Toppakketten", // translated
  topTours: "Toptours", // translated
  traveller: "Reiziger", // translated
  reviews: "Beoordelingen", // translated
  home: "Thuis", // translated
  packages: "Pakketjes", // translated
  experiences: "Ervaringen", // translated
  close: "Dichtbij", // translated
  loadingMessage: "Even geduld a.u.b. terwijl we zoeken naar de best beschikbare prijzen", // translated
  loadingMessageTheHotelCo: "Even geduld a.u.b. terwijl we zoeken naar de best beschikbare prijzen", // translated
  loadingMessageSearchStrip: "Even geduld a.u.b. terwijl we op zoek zijn naar de best beschikbare prijzen...", // translated
  topCountriesToVisit: "Toplanden om te bezoeken", // translated
  profile: "Profiel", // translated
  reservations: "Reserveringen", // translated
  address: "Adres", // translated
  firstName: "Voornaam", // translated
  lastName: "Achternaam", // translated
  email: "E-mail", // translated
  login: "Log in", // translated
  logout: "Uitloggen", // translated
  myProfile: "Mijn profiel", // translated
  myChatRooms: "Mijn chats", // translated 
  chatRoomsListEmpty: "Je hebt geen chatrooms voor dit account.", // translated 
  chatRoomsOpen: "Open", // translated 
  chatRoomsLastActivity: "Laatste activiteit", // translated 
  chatRoomsUnread: "Ongelezen", // translated 
  chatRoomsBadgeQuotation: "Offerte", // translated 
  chatRoomsBadgeTripOffer: "Reisaanbieding", // translated 
  chatRoomsOpenQuotationAria: "Offerte-chat openen: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "Chat voor open reisaanbiedingen: {{name}}", // translated 
  chatRoomsOpenGenericAria: "Chat openen: {{naam}}", // translated 
  quotationChatInvalidLink:
    "Ongeldige chatlink. Open een chat via uw profiel of offertelijst, of gebruik precies één van room_code of room_uid.", // translated 
  quotationChatNoTripDetails: "Reisdetails zijn niet beschikbaar voor deze chat.", // translated 
  chat: "Chat", // translated 
  verified: "Geverifieerd", // translated
  unverified: "Niet geverifieerd", // translated
  selectLanguage: "Selecteer taal", // translated
  selectCurrency: "Selecteer valuta", // translated
  upgrade: "Upgrade", // translated
  membership: "Lidmaatschap", // translated
  travelTrust: "Reisvertrouwen", // translated
  signInUp: "Aanmelden/Aanmelden", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates: "wereldwijde hotels en resorts tegen geweldige groothandelstarieven", // translated
  dashboard: "Dashboard", // translated
  pricing: "Prijzen", // translated
  refundable: "Terugbetaalbaar", // translated
  cars: "auto's", // translated
  cruises: "Cruises", // translated
  view: "Weergave", // translated
  price: "Prijs", // translated
  totalPrice: "Totale prijs", // translated
  filterRoomName: "Naam kamer filteren", // translated
  get: "Krijgen", // translated
  guestInformationValidation: "Gastinformatievalidatie", // translated
  reservation: "Reservering", // translated
  checkIn: "Check in", // translated
  checkOut: "Uitchecken", // translated
  paymentInitiattionErroeMessage: "We kunnen uw betalingsproces niet starten. Excuses voor het ongemak", // translated
  warning: "Waarschuwing", // translated
  couldNotFindPriceForDateWarning: "We konden geen prijs vinden voor deze datum. Probeer het opnieuw voor een andere datum", // translated
  searchFormValidationError: "Validatiefout zoekformulier", // translated
  pleaseSelectValidDateFirst: "Selecteer eerst een geldige datum", // translated
  searchError: "Zoekfout", // translated
  priceSearchInitiationError: "We kunnen het prijszoekproces niet starten. Probeer het later opnieuw. Excuses voor het ongemak", // translated
  searchWarning: "Zoekwaarschuwing", // translated
  couldNotFindPriceAndOrAvailability: "We konden geen prijs en/of beschikbaarheid vinden voor uw verzoek. Excuses voor het ongemak", // translated
  joinNow: "Word nu lid", // translated
  signIn: "Inloggen", // translated
  searchNow: "Zoek nu", // translated
  bookingFailed: "Boeking mislukt", // translated
  sorryForTheInconvenience: "Excuses voor het ongemak", // translated
  paymentFailedTryAgain: "Betaling mislukt. Probeer het opnieuw", // translated
  quickLinks: "Snelle links", // translated
  tours: "Rondleidingen", // translated
  termsAndConditions: "Voorwaarden", // translated
  pleaseWaitWhileInitiatingPayment: "Even geduld a.u.b. terwijl we uw betalingsproces starten", // translated
  back: "Rug", // translated
  nextStep: "Volgende stap", // translated
  book: "Boek", // translated
  checkout: "Uitchecken", // translated
  specifyPickUpPoint: "Specificeer het punt van uw favoriete afhaalpunt", // translated
  pickupPoint: "Ophaalpunt", // translated
  optional: "optioneel", // translated
  remarks: "Opmerkingen", // translated
  travellerInformation: "Reizigersinformatie", // translated
  bookingRemarks: "Opmerkingen bij boeking", // translated
  bookingOverview: "Boekingsoverzicht", // translated
  paymentFailed: "Betaling mislukt", // translated
  paymentSuccess: "Betaling gelukt", // translated
  at: "Bij", // translated
  person: "persoon", // translated
  cancellationPolicy: "Annuleringsvoorwaarden", // translated
  From: "Van", // translated
  to: "tot", // translated
  cancellationIs: "annulering is", // translated
  pickup: "Raap op", // translated
  flights: "Vluchten", // translated
  Accommodation: "Accommodatie", // translated
  payAndBook: "Betaal & Boek", // translated
  onRequest: "Op verzoek", // translated
  weAreFindingTheBestAvailableServices: "We vinden de best beschikbare services", // translated
  withTheBestAvailablePrices: "met de best beschikbare prijzen", // translated
  inRealTime: "live", // translated
  seconds: "seconden", // translated
  thisProcessCanTakeUpToOneMinute: "Dit proces kan tot 1 minuut duren", // translated
  pleaseDoNotRefreshThisPage: "Gelieve deze pagina niet te vernieuwen", // translated
  wellItSeemsItCanTakeBitLonger: "Nou... het lijkt erop dat het wat langer kan duren", // translated
  yourBrowserDoesNotSupportTheVideoTag: "Uw browser ondersteunt de videotag niet", // translated
  bookingSuccess: "Boeking succes", // translated
  bookingReference: "Boekingsreferentie", // translated
  referenceCopied: "Referentie gekopieerd", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation: "Binnenkort ontvang je een e-mail met alle benodigde informatie voor je reservering", // translated
  viewMore: "Bekijk meer", // translated
  readMore: "Lees verder", // translated
  customerSupport: "Klantenservice", // translated
  socialMedia: "Sociale media", // translated
  minutes: "minuten", // translated
  sendVoucherEmail: "Voucher-e-mail verzenden", // translated
  clickHere: "Klik hier", // translated
  proceed: "Doorgaan", // translated
  reference: "Referentie", // translated
  errorContentUnavailable: "Oeps! De inhoud die u zoekt bestaat niet. Neem contact met ons op over het probleem", // translated
  addressIsRequired: "adres is nodig", // translated
  emailHasBeenSent: "E-mail succesvol verzonden", // translated
  memberId: "Gebruikers ID", // translated
  sendUsYourRequest: "Stuur ons uw verzoek", // translated
  status: "Toestand", // translated
  emailIsRequired: "E-mail is vereist", // translated
  hour: "uur", // translated
  notAvailable: "Niet beschikbaar", // translated
  noReservationsForThisProduct: "Geen reserveringen voor dit product", // translated
  stars: "Sterren", // translated
  hours: "uur", // translated
  firstNameIsRequired: "voornaam is verplicht", // translated
  star: "Ster", // translated
  sendUsEmail: "Stuur ons een e-mail", // translated
  yourReservationIsInProgress: "Uw reservering is in behandeling", // translated
  cityIsRequired: "Stad is vereist", // translated
  km: "km", // translated
  sendCancellationEmail: "Annuleringsmail verzenden", // translated
  cancelled: "Geannuleerd", // translated
  visitSite: "Bezoek website", // translated
  currency: "Munteenheid", // translated
  firstNameMustContainAlphabetic: "De voornaam mag alleen alfabetische tekens bevatten", // translated
  score: "Scoren", // translated
  active: "Actief", // translated
  pending: "In behandeling", // translated
  privacyPolicy: "Privacybeleid", // translated
  lastNameIsRequired: "Achternaam is vereist", // translated
  emailNotSentTryAgain: "E-mail niet verzonden! Probeer het opnieuw", // translated
  sendUsRequest: "Stuur ons uw verzoek", // translated
  confirmed: "Bevestigd", // translated
  clearYourFilters: "Wis uw filteropties om de resultaten te bekijken", // translated
  leadGuest: "Hoofdgast", // translated
  pleaseCheckTheBox: "Vink het vakje aan om aan te geven dat u de verstrekte informatie heeft gelezen en ermee akkoord gaat, voordat u doorgaat naar de volgende stap.", // translated
  progressAt: "Vooruitgang bij", // translated
  lastNameMustContainAlphabetic: "De achternaam mag alleen alfabetische tekens bevatten", // translated
  minute: "minuut", // translated
  genderIsRequired: "Geslacht is vereist", // translated
  restaurants: "Restaurants", // translated
  phoneNumberIsRequired: "Telefoonnummer is vereist", // translated
  downloadVoucher: "Voucher downloaden", // translated
  security: "Beveiliging", // translated
  clearAllFilters: "Wis alle filters", // translated
  applicationAvailable: "applicatie beschikbaar", // translated
  invalidEmail: "Ongeldig e-mail", // translated
  iHaveReadAgreeWithAbove: "Ik heb het bovenstaande gelezen en ga ermee akkoord", // translated
  distanceFromSelection: "Afstand vanaf selectie", // translated
  titleIsRequired: "Titel is vereist", // translated
  postalCodeIsRequired: "Postcode is vereist", // translated
  noOptionsForSelectedFilters: "Er zijn geen opties beschikbaar om uw filters te matchen", // translated
  countryIsRequired: "Land is vereist", // translated
  nearby: "In de buurt", // translated
  found: "Gevonden", // translated
  phoneNumberInTheFormat: "Het telefoonnummer moet de notatie zonder spaties hebben", // translated
  maintenanceTitle: "Website in onderhoud", // translated 
  maintenanceDescription:
    "Wij voeren gepland onderhoud uit. Kom later terug.", // translated 
  maintenanceCountdownLabel: "Geschatte tijd", // translated 
  maintenanceLogoAlt: "Websitelogo", // translated 
  maintenanceDays: "Dagen", // translated 
  maintenanceHours: "Uren", // translated 
  maintenanceMinutes: "Minuten", // translated 
  maintenanceSeconds: "Tweede", // translated 
  maintenanceStatusBadge: "Gepland onderhoud", // translated 
  maintenanceRefresh: "Pagina", // translated 
  maintenanceExpired:
    "Het onderhoud zou binnenkort voltooid moeten zijn. Vernieuw de pagina.", // translated 
};


export default commonAndMisc;
